var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"selector",attrs:{"prepend-icon":"flag","items":_vm.items,"dark":_vm.dark,"menu-props":{minWidth:'1'},"flat":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.value.toUpperCase())+"\n  ")]}}]),model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-338c45da","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/language/LanguageSelector.vue
// module id = mJpz
// module chunks = 1